import { makeStyles } from '@mui/styles';
import classNames from 'classnames';
import * as _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { testSelectors, updateTest } from '../../store/test';

const useStyles = makeStyles({
  root: {
    width: '100%',
    height: '100%',
    resize: 'none',
    border: 'none',
    outlineOffset: '0px',
    outline: 'none',
    display: 'inline-block',
    padding: '3px 8px',
  },
});

type DescriptionInputProps = {
  hidden: boolean;
  isReadOnly?: boolean;
  onChange?: () => void;
};

const DescriptionInput: React.FC<DescriptionInputProps> = ({ hidden, isReadOnly, onChange }) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const selectedTest = useSelector(testSelectors.selectedTest);
  const description = selectedTest?.description || '';
  const [value, setValue] = useState(description);

  useEffect(() => {
    setValue(description);
  }, [description]);

  const dispatchChange = (value: string) => {
    selectedTest && dispatch(updateTest({ ...selectedTest, description: value }));
    onChange && onChange();
  };

  const handleChange: any = (event: any) => {
    setValue(event.target.value);
    dispatchChange(event.target.value);
  };

  return (
    <>
      {!hidden && (
        <textarea
          placeholder={isReadOnly ? '' : 'type description'}
          onChange={handleChange}
          value={value}
          className={classNames(classes.root)}
          rows={5}
          disabled={isReadOnly}
        />
      )}
    </>
  );
};

export { DescriptionInput };
